import React from 'react';
import Img from './component';

export default React.memo(Img);
